import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

const ViewContractPage = () => {
  const { id } = useParams();
  const decodedId = atob(id);

  const [contract, setContract] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContract = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_contract.php?coordinator_id=${decodedId}`
        );
        if (res.data.success) {
          setContract(res.data.contract);
        } else {
          setContract(null);
        }
      } catch (error) {
        console.error("Error fetching contract:", error);
        setContract(null);
      } finally {
        setLoading(false);
      }
    };

    fetchContract();
  }, [decodedId]);

  const handlePrint = () => {
    window.print();
  };

  if (loading)
    return <div className="text-center mt-5">Loading Contract...</div>;

  if (!contract)
    return <div className="text-center mt-5">Contract Not Found</div>;

  // Split saved signature (Example: "Mr~John Smith")
  let savedTitle = "";
  let savedSignature = "";

  if (contract.bwc_signature) {
    const parts = contract.bwc_signature.split("~");
    savedTitle = parts[0];
    savedSignature = parts[1];
  }

  const formatDate = (datetime) => {
  if (!datetime) return "";

  const date = new Date(datetime.replace(" ", "T")); // fix for Safari
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};

const getYear = (datetime) => {
  return datetime.split("-")[0];
};


  return (
    <div className="container mt-5 mb-5">
      <div className="text-center mb-4">
        <h2>Authormeet Confirmation & Contract</h2>
      </div>

      <div className="row mb-4">
        <div className="col-md-6 text-center">
          <h4>{contract.bwc_orgname}</h4>
          <p>
            {formatDate(contract.signed_at)} to {contract.bwc_enddate}{" "}
            {getYear(contract.signed_at)}
          </p>
          <strong>Authormeet Dates</strong>
        </div>

        <div className="col-md-6 text-center">
          <h4>Virtual/Online Bookstore</h4>
          {/* <p>{contract.year}</p> */}
          <p>{getYear(contract.signed_at)}</p>
          <strong>School Year</strong>
        </div>
      </div>

      <p>
        We wish to thank you for selecting Bookworm Central as your authormeet
        company.
      </p>

      <p>
        <strong>
          You may choose to receive your proceeds in cash, books, or a
          combination of the two.
        </strong>
      </p>

      <p><strong>You will receive:</strong></p>
      <ul>
        <li>25% cash / 35% books (over $8,000)</li>
        <li>20% cash / 30% books ($4,000 - $8,000)</li>
        <li>15% cash / 25% books (under $4,000)</li>
      </ul>

      <div className="row mt-4">
        {/* Coordinator Section */}
        <div className="col-md-6">
          <div className="mb-3">
            <label><strong>Agreed To Terms:</strong></label>
            <div>
              {contract.agree_status == 1 ? "Yes" : "No"}
            </div>
          </div>

          <div className="mb-3">
            <label><strong>Title:</strong></label>
            <div>{savedTitle}</div>
          </div>

          <div className="mb-3">
            <label><strong>Signature:</strong></label>
            <div
              style={{
                fontFamily: "'Cedarville Cursive', cursive",
                fontSize: "32px",
                transform: "skewY(-5deg)",
              }}
            >
              {savedSignature}
            </div>
          </div>
        </div>

        {/* Bookworm Central Section */}
        <div className="col-md-6 text-center">
          <h5>Bookworm Central</h5>

          <div className="mt-3">
            <div><strong>Title:</strong> Mrs</div>
            <div
              style={{
                fontFamily: "'Cedarville Cursive', cursive",
                fontSize: "32px",
                marginTop: "10px",
              }}
            >
              Laurie Rothenberg
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mt-5">
        <button
          type="button"
          onClick={handlePrint}
          className="btn btn-secondary"
        >
          Print Contract
        </button>
      </div>
    </div>
  );
};

export default ViewContractPage;
